import RefBooksModule from './refbooks.module';

import i18n from '../../i18n';
import { hashify } from '../../utils/arrays';
import { asc, desc } from '../../collection/sort';
import { find } from '../../utils/strings';





let ifn; i18n.then( i => ifn = i );

export default RefBooksModule.extend( {

    initialize(options = {}) {
        options.dragMode = undefined !== options.dragMode
            ? options.dragMode
            : false;

        RefBooksModule.prototype.initialize.call( this, options );
    },

    start() {
        const { paged } = this.options;
        paged.plugActionSource( this.Grid );

        this.listenTo( paged, 'activate deactivate', 
            () => {
                const current = paged.current();
                const activeId = current ? current.id : undefined;
                this.setState( { activeId, } );
                this.navigated();
            } );

        this.listenTo( this.options.filter, 'change',
            () => {
                const stateOptions = { page: 1 };
                if (!this.options.dragMode)
                    stateOptions.cluster = this.options.filter.get( 'cluster' );
                this.setState( stateOptions );

                const sortParams = this.options.dragMode
                    ? { sort: 'new-order', direction: 'asc' }
                    : undefined;
                this.sort( sortParams )
                    .then( () => this.filter() )
                    .then( () => this.render() )
                    .then( () => this.navigated() );
                    // this.bind( this.options.filter ).then( () => this.navigated() );
            } );

        return this.Grid.focus(),
            this;
    },

    stop() {
        const { paged } = this.options;

        paged.unplugActionSource( this.Grid );
        this.Grid.ungrab( paged );
        this.stopListening( paged );

        this.stopListening( this.options.filter );

        return this;
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort: sortField, direction, } = currentTarget.dataset;

            return this.setState( { page: 1, sort: sortField, direction, } ),
                this.sort()
                    // todo .then( () => this.bind( this.options.filter ) )
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

    },

    [RefBooksModule.event( 'Paging:page')](page) {
        this.setState( { page: +page, } );
        if (!this.options.dragMode)
            return this.render().then( () => this.navigated() );

        this.sort( { sort: 'new-order', direction: 'asc' } )
            .then( () => this.render() )
            .then( () => this.navigated() );
    },

    [RefBooksModule.event( 'Search:search')](search) {
        this.setState( { search, page: 1, } );
        if (!this.options.dragMode)
            return this.render().then( () => this.navigated() );

        this.sort( { sort: 'new-order', direction: 'asc' } )
            .then( () => this.render() )
            .then( () => this.navigated() );
    },

    [RefBooksModule.event( 'Grid:rows:order' )](permutation) {
        return this.reorder( permutation ), this.sort( { sort: 'new-order', direction: 'asc' } )
                .then( () => this.render() )
    },

    [RefBooksModule.event( 'Grid:swap-up')](index) {
        this.reorder( [+index, +index-1] );

        if (index == 0)
            this.setState( { page: this.options.paged.page - 1, } );

        this.sort( { sort: 'new-order', direction: 'asc' } )
            .then( () => this.render() );
    },

    [RefBooksModule.event( 'Grid:swap-down')](index) {
        this.reorder( [+index+1, +index] );

        if (index == this.options.paged.length - 1)
            this.setState( { page: this.options.paged.page + 1, } );

        this.sort( { sort: 'new-order', direction: 'asc' } )
            .then( () => this.render() );
    },

    serialize() {
        const { sort, direction, search: searchString, } = this.state();
        const { dragMode } = this.options;
        this.filter();

        const isolatedClusters = this.options.clusters.toJSON()
            .filter( cluster => cluster.isolated );
        const isolatedCount = isolatedClusters.length;
        
        return {
            actionList: this.options.paged.actions,
            collection: this.options.paged,
            sort, direction,
            dragMode, 
            orderChanged: this.isOrderChanged(),
            searchString,
            isolatedCount,
            nonIsolatedCount: this.options.clusters.length - isolatedCount,
            clusters: this.listClusters(),
            isolatedClusters,
            clusterPicked: this.currentCluster(),
        };
    },

    listClusters() {
        return [
            { id: -1, title: ifn( 'filters::global' ) },
            ...this.options.clusters.toJSON()
        ];
    },

    filterClusterFn(model, cluster) {
        return !cluster ||
            cluster.id == -1 && !model.get( 'cluster' ) ||
            cluster.id != -1 && model.get( 'cluster' ) && model.get( 'cluster' ).id == cluster.id;
    },

    // undefined for "global"
    currentCluster() {
        const clusterToSearch = this.options.dragMode 
            ? this.options.filter.get( 'sortCluster' )
            : this.state().cluster;

        // -1 == global, no need to find it
        if (clusterToSearch && clusterToSearch.id == -1)
            return clusterToSearch;

        // need to take cluster from list
        // to "isolated" property
        const [cluster] = this.options.clusters
            .toJSON()
            .filter( cluster => 
                clusterToSearch && cluster.id == clusterToSearch.id );

        return cluster;
    },

    sort(params = {}) {
        const { sort, direction, } = {
            ...this.state(), ...params
        };
        const sortByOrder = model => +model.get( 'order' );
        const sortById = model => +model.id;
        // for Type
        const sortByPeriod = model => +model.get( 'period_of_review_in_sec' );
        const sortField = sort === 'order' ? sortByOrder 
            : sort === 'id' ? sortById
            : sort === 'period_of_review_in_sec' ? sortByPeriod : sort;

        const cluster = this.currentCluster();
        const srcModels = this.options.source.models.filter( 
            model => this.filterClusterFn( model, cluster ) );

        const sorting = 'asc' === direction
            ? asc( srcModels, [sortField, sortById] )
            : desc( srcModels, [sortField, sortById] );
    
        return sorting.then( sortedModels => this.options.sorted.reset( sortedModels ) );
    },

    filterFn(/* model */) {
        return true;
    },

    filter() {
        const { search, page, limit, activeId, } = this.state();
        const source = this.options.sorted;
        const dest1 = this.options.filtered;
        const dest2 = this.options.paged;

        dest1.reset( source.models
            .filter( model => this.filterFn( model ) )
            .filter( model => find( [
                model.id, model.get( 'no' ),
                model.get( 'name' ), model.get( 'title' ),
                model.get( 'url' )], 
                search ) ) );
        
        dest2.reset( dest1.models.filter( (model, index) =>
            index >= (page - 1) * limit && index < page * limit ),
            // note silent: true
            // (to avoid automatic rerendering grid on "reset" event)
            { silent: true } );
    
        const activeIndex = dest2.findIndex( model => +model.id === +activeId );
        if (activeIndex > -1)
            dest2.activate( activeIndex );
        else
            dest2.restoreActive();
    
        dest2.total = dest1.length;
        dest2.page = page;
        dest2.limit = limit;
        dest2.npages = (dest2.total / dest2.limit | 0) + (dest2.total % dest2.limit == 0 ? 0 : 1);
    },

    isOrderChanged() {
        const f = prop => this.options.sorted.models
            .map( model => model.get( prop ) );

        const g = arr => arr
            .map( (el, value) => [value, el] )
            .sort( ([valueA, indexA], [valueB, indexB]) => indexA - indexB )
            .map( ([value]) => value )
            .join( ',' );

        return g( f( 'order' ) ) !== g( f( 'new-order' ) );
    },

    // [newOrder = 3, 0 or 5, 7, 1]
    reorder(newOrder) {
        // index === value, old position
        // i     === pos,   new position
        // order: new position -> old position

        const { page, limit } = this.options.paged;
        const offset = (page - 1) * limit;
        newOrder = newOrder.map( index => index + offset );

        const usedIndexes = hashify( newOrder );

        const permutation = [];
        for (let i = 0; i < this.options.filtered.length; i++)
            permutation.push( usedIndexes[i] ? newOrder.shift() : i );

        const m = this.options.filtered.models;
        permutation
            .map( (index, i) => [m[index], m[i]] )
            .map( ([modelHere, prevModelHere]) => [modelHere, prevModelHere.get( 'new-order' )] )
            .forEach( ([modelHere, prevOrderHere]) => 
                modelHere.set( 'new-order', prevOrderHere ) );

        return permutation;
    },

} );


// WEBPACK FOOTER //
// ./src/js/module/refbooks/refbooks.list.js